let browser_notice = ( function( $ ) {

	let outdated_browsers = [
		'msie'
	];

	let $notice_overlay  = $( '.crate-popup-overlay' );
	let $notice_content  = $( '#browser-notice' );

	let _init = function() {
		if ( outdated_browsers.includes( $.browser ) && ! _cookie_accepted() ) {
			_trigger_outdated_notification();
		}
	};

	let _trigger_outdated_notification = function() {
		$( 'body' ).addClass( 'popup-open' );

		$( '.browser-proceed, a.close' ).on( 'click', _continue_event );

		$notice_overlay.fadeIn();
		$notice_content.fadeIn();
		$notice_content.addClass( 'open' );
	};

	let _close_popup = function() {
		$( 'body' ).removeClass( 'popup-open' );

		$notice_content.fadeOut( 400 );
		$notice_overlay.fadeOut( 400 );

		setTimeout( function() {
			$notice_content.remove();
			$notice_overlay.remove();
		}, 400 );
	}

	let _continue_event = function( e ) {
		e.preventDefault();

		$.cookie( 'outdated_browser_accepted', true, { expires: 365 } );
		_close_popup();
	}

	let _cookie_accepted = function() {
		return $.cookie( 'outdated_browser_accepted' );
	}

	$( document ).ready( _init );

} )( jQuery );

module.exports = browser_notice;